import { ReactNode } from 'react'
import { LuChevronRight } from 'react-icons/lu'
import { cn } from '@cannect/lib/utils'

type MethodCardProps = {
  icon: ReactNode
  title: string
  description?: string
  disabled?: boolean
  onClick: () => void
}

// Card de linha cheia pra escolha de método — porte do padrão validado em
// manager-cannect/src/components/MethodCard, usado no login/gestão de 2FA
// daquele repo. Resolve a largura desigual dos botões de forma estrutural
// (cada linha é um bloco full-width com o mesmo layout).
// `appearance-none` é obrigatório: `preflight: false` no tailwind.config
// deste repo deixa o <button> com o chrome nativo do navegador, que não
// respeita o border-radius customizado e quebra a borda visualmente.
export const MethodCard = ({ icon, title, description, disabled, onClick }: MethodCardProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={cn(
      'flex min-h-[44px] w-full appearance-none items-center gap-3.5 rounded-xl border border-solid border-gray-200 bg-white p-4 text-left outline-none transition-colors hover:border-primary-300',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2',
      disabled && 'cursor-not-allowed opacity-50'
    )}>
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
      {icon}
    </span>
    <span className="flex-1">
      <span className="block text-sm font-semibold text-gray-900">{title}</span>
      {description && <span className="block text-xs text-gray-500">{description}</span>}
    </span>
    <LuChevronRight className="shrink-0 text-gray-400" size={18} aria-hidden="true" />
  </button>
)
